/**
 * Survey utility helpers for the TopCX Portal.
 * Replaces the survey app's helpers/utils.js with cookie-based auth.
 */

export const getCookieValue = (name) => {
  const value = document.cookie.match("(^|[^;]+)\\s*" + name + "\\s*=\\s*([^;]+)");
  return value ? value.pop() : null;
};

export const getApiConfig = () => ({
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

/**
 * Capitalize the first letter of a string.
 */
export const capitalize = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Get a CSS color value by name (used by echarts helpers).
 */
export const getColor = (name) => {
  const colors = {
    "gray-100": "#f1f5f9",
    "gray-200": "#e2e8f0",
    "gray-300": "#cbd5e1",
    "gray-400": "#94a3b8",
    "gray-500": "#64748b",
    "gray-600": "#475569",
    primary: "#6366f1",
    success: "#22c55e",
    danger: "#ef4444",
    warning: "#f59e0b",
    info: "#06b6d4",
  };
  return colors[name] || "#64748b";
};
